<template>
  <div id="app">
    <div style="height: 100%; position: relative">
      <!-- 顶部 -->
      <XjTop :key="new Date().getTime()" class="top"></XjTop>

      <!-- 路由页面 -->
      <div
        class="box-card"
        style="
          margin-left: 1%;
          background-color: #ffffff;
          overflow: auto;
          width: 98%;
          height: 100%;
        "
      >
        <router-view class="router-page" />
        <!-- 底部 -->
        <el-card class="box-card bottom-box">
          <XjBottom></XjBottom>
        </el-card>
      </div>
    </div>
  </div>
</template>


<script>
//引入组件
import XjTop from "./page/top/XjTop";
import XjBottom from "./page/bottom/XjBottom";

export default {
  name: "app",
  //定义组件
  components: {
    XjTop: XjTop,
    XjBottom: XjBottom,
  },
};
</script>

<style>
@import "@/assets/index.css";
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}
.router-page {
  background: #f4f7fc;
  margin-top: 80px;
}
.bottom-box {
  margin-left: 1%;
  background-color: #ffffff;
  width: 98%;
  height: 150px;
  margin-top: 1%;
  /* position: fixed; */
  /* bottom: 0px;/ */
}
</style>
